import React, { FC, useContext } from "react";
import { FiltersContext } from "../context/FiltersProvider";

const FiltersActions: FC = () => {
  const { actions, hasInitialFilters, hasFilters } = useContext(FiltersContext);
  return (
    <div className="filters-actions">
      <button
        className="apply-action"
        onClick={actions.onApply}
        disabled={!hasFilters}
      >
        Apply Filters
      </button>
      <button
        className="refresh-action"
        onClick={actions.onRefresh}
        disabled={hasInitialFilters}
      >
        <span className="fa fa-refresh" />
      </button>
    </div>
  );
};

export default FiltersActions;



// WEBPACK FOOTER //
// ./src/share/components/Filters/components/FiltersActions.tsx